module.exports = __webpack_public_path__ + "static/img/img-14.5c74777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-14.png
// module id = 4344
// module chunks = 1